// extracted by mini-css-extract-plugin
export default {"lowIcon":"PumpStatus_lowIcon__v6Qla","lowText":"PumpStatus_lowText__soxAA","expiringIcon":"PumpStatus_expiringIcon__1+VCG","expiringText":"PumpStatus_expiringText__LjGlq"};